import { Hexagon } from "@/ui/Hexagon";
import cn from "classnames";

import excellence from "./excellence.webp";
import innovation from "./innovation.webp";
import passion from "./passion.webp";
import tenacity from "./tenacity.webp";

import classes from "./styles.module.scss";

export default function ({ className = "py-5" }) {
  return (
    <div className={cn(className, classes.OurValues)}>
      <div className="opacity-10 d-none d-md-flex">
        <Hexagon className="bg-cyan" alt />
        <Hexagon className="bg-navy" alt />
        <Hexagon className="bg-blue" alt />
        <Hexagon className="bg-cyan" alt />
        <Hexagon className="bg-blue" alt />
        <Hexagon className="bg-blue" alt />
      </div>
      <div>
        <Hexagon className="bg-cyan opacity-10 d-none d-md-flex" alt />
        <Hexagon className="bg-blue" alt>
          <div className="d-flex align-items-center justify-content-center">
            <img src={excellence} alt="" />
          </div>
        </Hexagon>
        <Hexagon className="bg-blue" alt>
          <div className="p-2">
            <Hexagon className="bg-white w-100" alt>
              <div className="d-flex flex-column align-items-center justify-content-center">
                <h2 className="text-blue text-center fw-bold">
                  Our
                  <br /> Values
                </h2>
              </div>
            </Hexagon>
          </div>
        </Hexagon>
        <Hexagon className="bg-blue" alt>
          <div className="d-flex align-items-center justify-content-center">
            <img src={passion} alt="" />
          </div>
        </Hexagon>
        <Hexagon className="bg-cyan opacity-10 d-none d-md-flex" alt />
      </div>
      <div>
        <Hexagon className="bg-blue opacity-10 d-none d-md-flex" alt />
        <Hexagon className="bg-cyan opacity-10 d-none d-md-flex" alt />
        <Hexagon className="bg-blue" alt>
          <div className="d-flex align-items-center justify-content-center">
            <img src={innovation} alt="" />
          </div>
        </Hexagon>
        <Hexagon className="bg-blue" alt>
          <div className="d-flex align-items-center justify-content-center">
            <img src={tenacity} alt="" />
          </div>
        </Hexagon>
        <Hexagon className="bg-blue opacity-10 d-none d-md-flex" alt />
        <Hexagon className="bg-blue opacity-10 d-none d-md-flex" alt />
      </div>
    </div>
  );
}
